import React, { useEffect, useRef } from 'react'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const Benifits = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);
  
    useEffect(() => {
      const cards = cardRefs.current;
  
      const initialPositions = [
        { x: 0, y: 100, opacity: 0 },
        { x: 0, y: 150, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
        { x: 0, y: 200, opacity: 0 },
      ];
  
      cards.forEach((card, index) => {
        gsap.fromTo(
          card,
          initialPositions[index], 
          {
            x: 0,
            y: 0,
            opacity: 1,
            duration: 1,
            ease: "power3.out",
            scrollTrigger: {
              trigger: card,
              start: "top 100%",
              toggleActions: "play none none none",
            //   markers: true
            },
          }
        );
  
        gsap.set(card, { transformOrigin: "center" });
  
        card.addEventListener("mouseenter", () => {
          gsap.to(card, { scale: 1.05, duration: 0.3 });
        });
  
        card.addEventListener("mouseleave", () => {
          gsap.to(card, { scale: 1, duration: 0.3 });
        });
      });
    }, []);
    return (
        <>
            <section className='benifitsprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="beniftschlprnt">
                        <h2>Our Core Values</h2>
                        <div className="benifitscardsprnt">
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[0] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Chatandpay\benifitcardoneimg2.png" alt="benifitcardoneimg2" />
                                </div>
                                <img className='img-fluid' src="\assets\Aboutus\Authenticity.svg" alt="Authenticityimg" />
                                <h3>Authenticity</h3>
                                <p>Empower users to express their true selves.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[1] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Aboutus\valuespostionimgtwo.png" alt="valuespostionimgtwoimg" />
                                </div>
                                <img className='img-fluid' src="\assets\Aboutus\Privacy.svg" alt="Privacyimg" />
                                <h3>Privacy</h3>
                                <p>Protecting personal space and data at all costs.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[2] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Aboutus\valuespostionimgthree.png" alt="valuespostionimg" />
                                </div>
                                <img className='img-fluid'  src="\assets\Aboutus\Innovation4.svg" alt="Innovation4" />
                                <h3>Innovation</h3>
                                <p>Pioneering technologies that challenge the status quo.</p>
                            </div>
                            <div className="cardonebenifits" ref={(el) => (cardRefs.current[3] = el)}>
                                <div className="imgprntcard">
                                    <img className='img-fluid' src="\assets\Aboutus\valuespostionimgfour.png" alt="valuespostionimg" />
                                </div>
                               <img className='img-fluid' src="\assets\Aboutus\Community.svg" alt="Communityimg" />
                                <h3>Community</h3>
                                <p>Building a space where connections are meaningful and secure.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Benifits